import React from "react";
import "aos/dist/aos.css";
import AOS from "aos";

function Script() {
  AOS.init();
  return (
    <>
      <script src="https://unpkg.com/aos@2.3.1/dist/aos.js"></script>
      <link href="https://unpkg.com/aos@2.3.1/dist/aos.css" rel="stylesheet" />
    </>
  );
}

export default Script;
